import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useMembers } from '../context/membersContext.tsx';
import Navbar from './NavBar';
import Loading from './Loading.jsx';
import '../index.css';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import background1 from '../images/background.png';
import background2 from '../images/background2.png';
import next from '../images/next.png';
import back from '../images/back.png';

const backgroundStyles = {
  main: {
    backgroundImage: `url(${background1})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    overflowX: "hidden",
  },
  secondary: {
    backgroundImage: `url(${background2})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    width: "100%",
    height: "auto",
    overflowX: "hidden",
  }
};

const MemberPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const { members, loading } = useMembers();
  const [member, setMember] = useState(location.state || null);
  const iconSize = window.innerWidth > 768 ? 48 : 32;

  useEffect(() => {
    if (!member) {
      const foundMember = members.find((m) => m.name.split(' ').join('-').toLowerCase() === id);
      setMember(foundMember);
    }
  }, [id, member, members]);

  if (loading || !member) return <Loading />;

  return (
    <>
      <Navbar />
      <section className="min-h-screen w-full bg-mainBlue pb-12 lg:px-32 md:px-20 md:pt-48 pt-20" style={backgroundStyles.main}>
        <div className="flex flex-col md:flex-row lg:items-center items-start justify-between w-full h-auto">
          <div className="relative md:w-1/2 w-full" style={{ height: '75vh' }}>
            <img
              src={member.photoWithoutBackgroundURL}
              className="absolute top-0 left-0 w-full h-full object-cover opacity-70 md:object-contain"
              alt={member.name}
            />
          </div>
          <div className="flex flex-col md:w-1/2 w-full md:pl-12 text-white mt-3 pl-2">
            <h1
              className="member-name my-4 font-extrabold boldText pt-5"
            >
              {member.name}
            </h1>
            <div className="flex items-center my-6 gap-8">
              <div className="flex items-center mb-6 gap-2 md:gap-16 justify-between px-3 w-3/4 ">
                <p className="member-role font-bold">{member.role}</p>
                <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="hover:opacity-80 flex items-center justify-center" aria-label="LinkedIn Profile">
                  <svg width={iconSize} height={iconSize} viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_3_545)">
                      <path d="M45.1135 0.140625H4.21038C2.251 0.140625 0.666626 1.6875 0.666626 3.6V44.6719C0.666626 46.5844 2.251 48.1406 4.21038 48.1406H45.1135C47.0729 48.1406 48.6666 46.5844 48.6666 44.6813V3.6C48.6666 1.6875 47.0729 0.140625 45.1135 0.140625ZM14.9073 41.0437H7.78225V18.1312H14.9073V41.0437ZM11.3448 15.0094C9.05725 15.0094 7.21038 13.1625 7.21038 10.8844C7.21038 8.60625 9.05725 6.75937 11.3448 6.75937C13.6229 6.75937 15.4698 8.60625 15.4698 10.8844C15.4698 13.1531 13.6229 15.0094 11.3448 15.0094ZM41.5697 41.0437H34.4541V29.9062C34.4541 27.2531 34.4072 23.8312 30.751 23.8312C27.0479 23.8312 26.4854 26.7281 26.4854 29.7188V41.0437H19.3791V18.1312H26.2041V21.2625H26.2979C27.2447 19.4625 29.5698 17.5594 33.0291 17.5594C40.2385 17.5594 41.5697 22.3031 41.5697 28.4719V41.0437Z" fill="white"/>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
            <h3 className="member-description px-3">{member.description || 'No bio available'}</h3>
          </div>
        </div>
      </section>
      {member.relatedPhotosURL?.length > 0 && (
        <div className="md:py-32 py-16 md:px-16 relative" style={backgroundStyles.secondary}>
          <Slide
            slidesToScroll={1}
            slidesToShow={1}
            indicators={true}
            canSwipe={true}
            infinite={true}
            prevArrow={<img src={back} alt="Prev" />}
            nextArrow={<img src={next} alt="Next" />}
          >
            {member.relatedPhotosURL.map((photo, index) => (
              <div key={index} className="flex justify-center items-center w-full h-full">
                <img
                  src={photo}
                  className="w-10/12 h-auto object-contain opacity-100 rounded-3xl my-auto"
                  alt={`Related ${index + 1}`}
                />
              </div>
            ))}
          </Slide>
        </div>
      )}
    </>
  );
};

export default MemberPage;
